export var EVENT_TYPE;
(function (EVENT_TYPE) {
    EVENT_TYPE["load_widget"] = "load_widget";
    EVENT_TYPE["open_small_card"] = "open_small_card";
    EVENT_TYPE["see_small_card_page"] = "see_small_card_page";
    EVENT_TYPE["load_wall_of_love"] = "load_wall_of_love";
    EVENT_TYPE["load_marquee"] = "load_marquee";
})(EVENT_TYPE || (EVENT_TYPE = {}));
